import { type FC, useEffect, useState } from "react"

import type { LandingPageHeaderBlock, LandingPageNavigationPage } from "@forento/core/models/landing"

import HeaderBlockPreview from "../preview/HeaderBlockPreview"
import EditorShell from "./EditorShell"

type Props = {
	block: LandingPageHeaderBlock
	onChange: (block: LandingPageHeaderBlock) => void
	onClose: () => void
	navigationPages: LandingPageNavigationPage[]
	currentPath: string
}
const HeaderBlockEditor: FC<Props> = ({ block, onChange, onClose, navigationPages, currentPath }) => {
	const [isAuthVisible, setIsAuthVisible] = useState(block.content.isAuthVisible)

	useEffect(() => {
		onChange({ type: "header", content: { isAuthVisible } })
	}, [isAuthVisible, onChange])

	return (
		<EditorShell onClose={onClose}>
			<div className="pt-16 sm:pt-20">
				<HeaderBlockPreview
					block={{ type: "header", content: { isAuthVisible } }}
					navigationPages={navigationPages}
					currentPath={currentPath}
				/>
			</div>
			<div className="mx-auto max-w-7xl px-6 py-6 lg:px-8">
				<div className="rounded-2xl border border-black/10 bg-white p-5 shadow-sm">
					<div className="mb-3 text-sm font-semibold text-gray-900">Account buttons</div>
					<label className="flex cursor-pointer items-center gap-2.5">
						<input
							type="checkbox"
							checked={isAuthVisible}
							onChange={e => setIsAuthVisible(e.target.checked)}
							className="cursor-pointer rounded border-stone-300 text-stone-700"
						/>
						<span className="text-sm text-stone-600">
							Show the sign in and sign up buttons on this page
						</span>
					</label>
					<p className="mt-2 text-xs text-stone-500">
						Signed-in students see a button to their academy instead. Hide them to keep a sales page focused
						on its own call to action.
					</p>
				</div>
			</div>
		</EditorShell>
	)
}

export default HeaderBlockEditor
